import * as Dayjs from 'dayjs'
import Is from '../../../client/is.js'
import Toast from '../../../client/toast.js'

// noinspection JSFileReferences
import SweetAlert2 from 'sweetalert2/dist/sweetalert2.min.js'

export default class Checkout
{
	static _value = {}

	static _ship_fee = 0

	static _store_fee

	static _store_fee_used = 0

	static _point_percent

	static _point_used

	static _gmo_shop_id

	static init(gmo_shop_id, point_percent, store_fee, guest)
	{
		this._gmo_shop_id = gmo_shop_id

		this._point_percent = point_percent
		this._store_fee = store_fee

		this.set_pay_type($('#form')[0].payment.value)
		this.deliver_target($('#address_target').val(), true)
		this.show_register(!guest || $('#register_enabled').prop('checked'), true)

		this._save_field()
		$('#form input, #form select, textarea').on('change', () => this._save_field())

		App.common.Ui.autokana('input[name="orderer[name_last]"]', 'input[name="orderer[ruby_last]"]')
		App.common.Ui.autokana('input[name="orderer[name_first]"]', 'input[name="orderer[ruby_first]"]')
	}

	static _save_field(no_update = false)
	{
		this._value = {}

		$('#form input, #form select, #form textarea').each((index, element) =>
		{
			if(!element.name) return

			switch(element.type)
			{
				case 'radio' :
					if(!element.checked) return
				break

				case 'checkbox' :
					element.value = element.checked ? '1' : '0'
				break
			}

			this._value[element.name] = element.value
		})

		App._common.cookie('shipping', JSON.stringify(this._value))
		App._common.cookie('note', $('textarea[name="note"]').val())

		this.update_coupon('#coupon', false, no_update)
		this.update_point('#point', false, no_update)
	}

	static load_address(form, postal, prefecture, address)
	{
		$.get('/_postal/', {code: form[postal].value}, (data) =>
		{
			if(data.error) Toast.warning(data.error)
			else
			{
				form[prefecture].value = data.prefecture
				form[address].value = data.address

				this._save_field()
				this.ship_fee()
			}
		})

		form['orderer[address_local]'].focus()
	}

	static show_register(enable, no_update = false)
	{
		if(enable)
		{
			$('#register input').prop('disabled', false)
			$('#register').show()

			$('#coupon_input').show()
			$('#coupon_input input').prop('disabled', false)

			$('#coupon_warning').hide()
			if(!no_update) this.update_total()
		}
		else
		{
			$('#register').hide()
			$('#register input').prop('disabled', true)

			$('#coupon_input').hide()
			$('#coupon_input input').prop('disabled', true)

			$('#coupon_warning').show()
			this.update_total()
		}
	}

	static deliver_target(target, no_update = false)
	{
		if(target === '')
		{
			$('#deliver_area input, #deliver_area select, .deliver_area input').prop('disabled', false)
			$('#deliver_area, .deliver_area').removeClass('hidden')
		}
		else
		{
			$('#deliver_area, .deliver_area').addClass('hidden')
			$('#deliver_area input, #deliver_area select, .deliver_area input').prop('disabled', true)
		}

		this.ship_fee(no_update)
	}

	static set_pay_type(type)
	{
		$('#pay_card').addClass('hidden')
		$('#pay_store').addClass('hidden')
		$('#pay_bank').addClass('hidden')

		$(`#pay_${type}`).removeClass('hidden')
		App._common.cookie('payment', type)

		if(type === 'store')
		{
			this._store_fee_used = this._store_fee

			$('#pay_store input').prop('disabled', false)
			$('#store_fee_area').show()
		}
		else
		{
			this._store_fee_used = 0

			$('#store_fee_area').hide()
			$('#pay_store input').prop('disabled', true)
		}

		if(type === 'card')
		{
			$('#pay_card input, #pay_card select').prop('disabled', false)
			this.change_card($('#form')[0].card.value)
		}
		else
		{
			$('#pay_card input, #pay_card select').prop('disabled', true)
			this.change_card()
		}
	}

	static save_store(store)
	{
		App._common.cookie('store', store)
	}

	static update_coupon(input, notify = true, no_update = false)
	{
		const data = new FormData()
		const coupon = $(input).prop('disabled') ? '' : $(input).val()

		if(coupon === '' || coupon === undefined)
		{
			if(!no_update) this.update_total()
			App._common.cookie('coupon', null)

			if(notify) Toast.success('クーポンを解除しました')
			return
		}

		data.set('__action', 'coupon')
		data.set('coupon', coupon)

		$.ajax({
			url : '/checkout/',
			type: 'POST',

			processData: false,
			contentType: false,

			data   : data,
			success: (data) =>
			{
				if(data.success)
				{
					App._common.cookie('coupon', coupon)
					this.update_total()

					if(notify) Toast.success(data.message)
				}
				else
				{
					Toast.warning(data.message)
				}
			},
		})
	}

	static update_point(input, notify = true, no_update = false)
	{
		const data = new FormData()
		this._point_used = Number($(input).val())

		if(this._point_used === 0)
		{
			if(!no_update) this.update_total()
			App._common.cookie('point', null)

			if(notify) Toast.success('利用ポイント数を更新しました')
			return
		}

		data.set('__action', 'point')
		data.set('point', this._point_used)

		$.ajax({
			url : '/checkout/',
			type: 'POST',

			processData: false,
			contentType: false,

			data   : data,
			success: (data) =>
			{
				if(data.success)
				{
					if(notify) Toast.success(data.message)

					App._common.cookie('point', this._point_used)
					this.update_total()
				}
				else Toast.warning(data.message)
			},
		})
	}

	static update_total(callback = null)
	{
		const coupon = $('#coupon').prop('disabled') ? '' : ($('#coupon').val() ?? '')

		$.get(`/checkout_total/?coupon=${coupon}&point=${$('#point').val()}`, (data) =>
		{
			$('#subtotal').text(data.subtotal.toLocaleString())
			$('#total').text(data.total.toLocaleString())

			$('#earn').text(data.earned.toLocaleString())

			$('#discount_coupon').text(`${data.coupon > 0 ? '-' : ''}${data.coupon.toLocaleString()}`)
			$('#discount_point').text(`${data.point > 0 ? '-' : ''}${data.point.toLocaleString()}`)

			$('#ship_fee').text(data.shipping.toLocaleString())
			$('#free_left').text(data.free_shipping.toLocaleString())

			if(data.free_shipping > 0) $('#free, #recommended').show()
			else $('#free, #recommended').hide()

			if(typeof callback === 'function') callback(data.total)
		})
	}

	static ship_fee(no_update = false)
	{
		const input = $('#address_target').val() === '0' ? '#orderer_prefecture' : '#deliver_prefecture'

		const prefecture = $(input).val()
		if(!prefecture) return

		const data = new FormData()

		data.set('__action', 'ship_fee')
		data.set('prefecture', prefecture)

		$.ajax({
			url : '/checkout/',
			type: 'POST',

			processData: false,
			contentType: false,

			data   : data,
			success: (data) =>
			{
				if(data.success)
				{
					this._ship_fee = data.payload.ship_fee
					this._save_field(no_update)

					this._ship_date(data.payload.earliest)
				}
				else Toast.warning(data.message)
			},
		})

		this._ship_date()
	}

	static _ship_date(earliest)
	{
		if(!earliest) return

		const element = $('input[name="ship_date"]')
		element.data('min-date', earliest)

		const date = element.val()
		const picker = element.data('daterangepicker')

		if(picker)
		{
			if(date && Dayjs(date).unix() < Dayjs(earliest).unix())
			{
				picker.setStartDate(earliest)
				element.val(earliest)
			}

			const [year, month, day] = earliest.split('-')

			picker.minDate.set('year', year)
			picker.minDate.set('month', month - 1)
			picker.minDate.set('date', day)

			try
			{
				picker.renderCalendar('left')
			}
			catch(exception)
			{
			}

			picker.updateView()
		}
	}

	static change_card(card)
	{
		if(card === '')
		{
			$('#pay_card input, #pay_card select:not([name="card"])').prop('disabled', false)
			$('#card').show()
		}
		else
		{
			$('#card').hide()
			$('#pay_card input, #pay_card select:not([name="card"])').prop('disabled', true)
		}
	}

	static _gmo_init = false

	static send(form)
	{
		try
		{
			if(form.hold.value === '1')
			{
				Toast.warning(`カード決済に進めませんでした。時間を置き、再度お試しいただくか、別の決済方法をご利用ください。`)
				return
			}

			if(form.payment.value !== 'card' || form.card.value !== '')
			{
				this._process(form)
				return
			}

			if(!this._gmo_init)
			{
				this._gmo_init = true
				Multipayment.init(this._gmo_shop_id)
			}

			let month = form.expiry_month.value
			if(month < 10) month = `0${month}`

			Multipayment.getToken({
				cardno      : form.number.value,
				expire      : form.expiry_year.value + month,
				securitycode: form.code.value,
				holdername  : form.name.value,
			}, (data) =>
			{
				try
				{
					if(data.resultCode !== '000') throw new Error(`Bad result code : ${data.resultCode}`)
					this._process(form, data.tokenObject.token)
				}
				catch(exception)
				{
					const code = Is.filled(data.resultCode) ? data.resultCode : '無し'
					Toast.warning(`カード決済に進めませんでした。時間を置き、再度お試しいただくか、別の決済方法をご利用ください。 (エラーコード : ${code})`)
				}
			})
		}
		catch(exception)
		{
			console.warn(exception)
		}
	}

	static _process(form, token = '')
	{
		delete this._value.number
		delete this._value.name
		delete this._value.expiry_year
		delete this._value.expiry_month
		delete this._value.code

		App._common.cookie('shipping', JSON.stringify(this._value))

		const data = new FormData()
		data.set('__action', 'submit')

		data.set('token', token)
		data.set('session', form.session.value)

		App.common.Network.post('/checkout/', data, (success, payload) =>
		{
			if(success) location.href = `/purchased/${payload.identifier}`
			else if(payload && payload.type === 'payment')
			{
				SweetAlert2.fire({
					html             : `<div class="font-bold text-xl text-center">【決済エラーが発生した場合の確認手順について】</div>
<div class="mt-5 md:mt-10">
	お手元のクレジットカードの有効期限を今一度ご確認くださいませ。<br>
	有効期限及びセキュリティーコードに誤りがない場合は、クレジットカード裏面のお問合せ先にご連絡いただき、事情をご説明ください。<br>
	当サイトでのカードのご利用制限解除のお手続き完了後に再度お支払い手続きを実施ください。<br>
	何かご不明な点がありましたら、サポートセンター(<a href="tel:0471795866">04-7179-5866</a>)までご連絡いただけますと幸いです。<br>
</div>

<div class="mt-5">
	お手数をお掛けしますが、ご確認の程よろしくお願い申し上げます。 
</div>`,
					confirmButtonText: '閉じる',
					showClass        : {
						popup: 'animate__animated animate__fadeIn animate__faster',
					},
				})
			}
		})
	}
}
